import { Button } from '@mui/material';
import { styled } from '@mui/material/styles';
import { useTranslation } from 'react-i18next';

import { StyledLoadingButton } from '../../../../components/forms/LoadingButton';

const StyledFooter = styled('div')({
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'flex-end',
    marginTop: '1rem'
});

interface FooterProps {
    onCancel: () => void;
    onSubmit: () => void;
    canSubmit: boolean;
    isLoading: boolean;
}

const Footer: React.FC<FooterProps> = ({ onCancel, onSubmit, canSubmit, isLoading }) => {
    const { t } = useTranslation('portal');

    return (
        <StyledFooter>
            <Button onClick={onCancel} variant="outlined">
                {t('users.actions.cancel')}
            </Button>
            <StyledLoadingButton
                sx={{ marginLeft: '0.5rem' }}
                onClick={onSubmit}
                disabled={!canSubmit}
                variant={'contained'}
                type={'submit'}
                loading={isLoading}
            >
                {t('users.actions.save')}
            </StyledLoadingButton>
        </StyledFooter>
    );
};

export default Footer;
